import { render, staticRenderFns } from "./Insurances.vue?vue&type=template&id=e2bfa0d6&scoped=true&"
import script from "./Insurances.vue?vue&type=script&lang=js&"
export * from "./Insurances.vue?vue&type=script&lang=js&"
import style0 from "./Insurances.vue?vue&type=style&index=0&id=e2bfa0d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2bfa0d6",
  null
  
)

export default component.exports